import Main from '../../components/layout/Main';
import ProfileMainContent from './main';

function ProfileIndex() {
  return (
    <Main
      main={<ProfileMainContent />}
      contentLeft={null}
      contentRight={null}
    />
  );
}

export default ProfileIndex;
